<template>
  <router-link
    :class="active ? 'bg-gray-100' : ''"
    class="h-full flex justify-center items-center w-20"
    :to="{ name: meta.name }"
    @click.native="changeMenuActive"
  >
    <div
      class="flex-col items-center justify-center text-center th-hover-pointer"
    >
      <!-- <div class="m-0"> -->
      <svg
        :class="active ? 'text-primary' : 'text-darkblue'"
        class="w-6 h-6 mb-1 mx-auto"
        v-if="meta.icon === 'home'"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
        ></path>
      </svg>
      <!-- <home-icon
        :class="active ? 'active-menu' : ''"
        class="w-full mb-1"
        v-if="meta.icon === 'home'"
      /> -->
      <svg
        :class="active ? 'text-primary' : 'text-darkblue'"
        class="w-6 h-6 mb-1 mx-auto"
        v-if="meta.icon === 'search'"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        ></path>
      </svg>
      <!-- <search-icon class="w-full mb-1" v-if="meta.icon === 'search'" /> -->
      <svg
        :class="active ? 'text-primary' : 'text-darkblue'"
        class="w-6 h-6 mb-1 mx-auto"
        v-if="meta.icon === 'bookmark'"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
        ></path>
      </svg>
      <!-- <bookmark-icon class="w-full mb-1" v-if="meta.icon === 'bookmark'" /> -->
      <svg
        :class="active ? 'text-primary' : 'text-darkblue'"
        class="w-6 h-6 mb-1 mx-auto"
        v-if="meta.icon === 'screen'"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        ></path>
      </svg>
      <!-- <screen-icon class="w-full mb-1" v-if="meta.icon === 'screen'" /> -->
      <!-- </div> -->
      <div :class="active ? 'active-menu' : ''" class="menu-title">
        {{ meta.title }}
      </div>
    </div>
  </router-link>
</template>

<script>
// const HomeIcon = () => import('@/components/Icon/Home')
// const SearchIcon = () => import('@/components/Icon/Search')
// const BookmarkIcon = () => import('@/components/Icon/Bookmark')
// const ScreenIcon = () => import('@/components/Icon/Screen')
export default {
  props: {
    meta: { type: Object },
    active: { type: Boolean },
  },
  components: {
    // HomeIcon,
    // SearchIcon,
    // BookmarkIcon,
    // ScreenIcon
  },
  methods: {
    changeMenuActive() {
      if (this.currentMenu !== this.meta.name) this.$store.commit('SET_STATE', { currentMenu: this.meta.name })
      // this.$router.push({ name: this.meta.name })
    },
  },
  computed: {
    currentMenu() { return this.$store.state.currentMenu },
  },
}
</script>

<style>
.active-menu {
  @apply text-primary font-bold text-xs !important;
}

.menu-title {
  @apply text-xs font-bold !important;
}
</style>
